/* ============================================
   ET - Video — horizontal SwiperJS slider of portrait video cards
   with lazy click-to-play (uploaded Shopify video or YouTube/Vimeo embed).
   Slide widths come from CSS (--et-video-slide-*), so slidesPerView:'auto'.
   ============================================ */
(function () {
  'use strict';

  var SWIPER_SEL = '[data-et-video-swiper]';
  var done = new WeakSet();

  /* ---------- Slider ---------- */
  function num(el, attr, fallback) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? fallback : v;
  }

  function build(el) {
    if (done.has(el)) return;
    if (typeof window.Swiper !== 'function') return;
    done.add(el);
    /* eslint-disable no-new */
    // No CSS width on slides — Swiper sets the width via slidesPerView (count).
    new window.Swiper(el, {
      slidesPerView: num(el, 'data-slides-m', 1.5),
      spaceBetween: 8,
      grabCursor: true,
      breakpoints: {
        750: { slidesPerView: num(el, 'data-slides-d', 4) }
      }
    });
  }

  function initSliders(scope) {
    (scope || document).querySelectorAll(SWIPER_SEL).forEach(build);
    if (typeof window.Swiper === 'function') return;
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof window.Swiper === 'function') {
        clearInterval(timer);
        document.querySelectorAll(SWIPER_SEL).forEach(build);
      } else if (++tries > 300) {
        clearInterval(timer);
      }
    }, 50);
  }

  /* ---------- Click to play ---------- */
  function playCard(card) {
    var target = card.querySelector('[data-et-video-player]');
    if (!target) return;

    // Once loaded, the play button stays hidden for good — native controls
    // handle pause/resume.
    card.classList.add('is-playing');

    if (target.querySelector('video, iframe')) return;

    var tpl = card.querySelector('[data-et-video-embed]');
    if (!tpl) return;
    target.appendChild(tpl.content.cloneNode(true));

    var video = target.querySelector('video');
    if (video && typeof video.play === 'function') {
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    }
  }

  function onClick(e) {
    var trigger = e.target.closest('[data-et-video-trigger]');
    if (!trigger) return;
    var card = trigger.closest('[data-et-video]');
    if (card) playCard(card);
  }

  function init(scope) {
    initSliders(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('click', onClick);
  window.addEventListener('load', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();
